import React from "react";
import { Box, type BoxProps, Text } from "@chakra-ui/react";
import { colors } from "../constants/GlobalStyles";
import LoadingAnimalAnimation from "./LoadingAnimalAnimation";
import JungleLogo from "../images/JungleLogo";

type LoadingViewComponentProps = {
  loadingMessage?: string;
  minimumHeight?: BoxProps["minHeight"];
};

function LoadingViewComponent({ loadingMessage, minimumHeight }: LoadingViewComponentProps) {
  return (
    <Box
      background={colors.surface.offWhite}
      display="flex"
      flexDirection="column"
      minHeight={minimumHeight ?? { base: "90vh", md: "100vh" }}
      width="100%"
      overflow="hidden"
    >
      <Box
        display="flex"
        flexDir="column"
        alignItems={"center"}
        background={colors.surface.offWhite}
        flex={1}
        margin="0 auto"
        justifyContent="center"
      >
        <Box display="flex" alignItems="center" justifyContent="center" mb="32px">
          <JungleLogo height={100} />
        </Box>
        <Text
          color={colors.text.header}
          fontWeight={600}
          fontSize="24px"
          lineHeight="32px"
          fontStyle="normal"
          paddingBottom="8px"
        >
          {loadingMessage}
        </Text>
        <LoadingAnimalAnimation />
      </Box>
    </Box>
  );
}

export default LoadingViewComponent;
